// Navbar module - custom active link logic only (Bootstrap handles collapse via data-attributes)
export default class Navbar {
  constructor(element) {
    this.element = element;
    this.navLinks = element.querySelectorAll('.nav-link');
    this.init();
  }

  init() {
    // Handle active link state
    this.navLinks.forEach(link => {
      link.addEventListener('click', () => {
        // Remove active from all links
        this.navLinks.forEach(l => l.classList.remove('active'));
        // Add active to clicked link
        link.classList.add('active');
      });
    });

    // Close mobile menu when link is clicked (Bootstrap handles collapse automatically)
    const navCollapse = this.element.querySelector('.navbar-collapse');
    if (navCollapse) {
      this.navLinks.forEach(link => {
        link.addEventListener('click', () => {
          if (window.innerWidth < 992) {
            // Bootstrap collapse instance
            const bsCollapse = bootstrap.Collapse.getInstance(navCollapse);
            if (bsCollapse) {
              bsCollapse.hide();
            }
          }
        });
      });
    }

    // Fixed navbar when scrolling down
    window.addEventListener('scroll', () => {
      if (window.scrollY > 100) {
        this.element.classList.add('fixed-top');
        this.element.style.transitionProperty = 'all';
        this.element.style.transitionDuration = '0.5s';
        this.element.style.transitionTimingFunction = 'ease';
      } else {
        this.element.classList.remove('fixed-top');
        this.element.style.transitionProperty = 'all';
        this.element.style.transitionDuration = '0.5s';
        this.element.style.transitionTimingFunction = 'ease';
      }
    });
  }
}
